import type { DashboardSummary } from "../../shared/types";
import { mockSummary } from "../mocks/summary";
import { getWithFallback } from "./apiClient";

export function getDashboardSummary(): Promise<DashboardSummary> {
  return getWithFallback("/summary", () => mockSummary);
}
